import { EnumTipoMittenteDTOCodice } from '@framework/api-client/api/inquiries-compile/schemas/enumTipoMittenteDTOCodice.ts';
import { type TipoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/tipoComunicazioneDTO.ts';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { CommunicationSubprocedureSelectInput } from '../office/CommunicationSubprocedureSelectInput.tsx';
import { InputRenderRow } from '../styled/InputRenderRow.tsx';

interface ICommunicationSenderInputProps {
  communicationType: TipoComunicazioneDTO;
}

export function CommunicationSenderInput(
  props: ICommunicationSenderInputProps,
) {
  const { communicationType } = props;

  const { t } = useTranslation();

  const senderOption = communicationType?.tipoMittente?.denominazione;

  const title = t('communication-type.sender', 'Mittente');

  if (
    communicationType?.tipoMittente?.codice !==
    EnumTipoMittenteDTOCodice.ENDOPROCEDIMENTI_PRIMO_LIVELLO
  ) {
    return (
      <InputRenderRow
        title={title}
        input={<Input readOnly value={senderOption ?? ''} size="large" />}
      />
    );
  }

  return (
    <InputRenderRow
      title={title}
      input={
        <FormItem
          name="idProcedimentoMittente"
          label={t(
            'communication-type.subprocedure-sender',
            'Endoprocedimento mittente',
          )}
          layout={{ removeHelpMargin: true }}
        >
          <CommunicationSubprocedureSelectInput
            name={'idProcedimentoMittente'}
            size="large"
            placeholder={t(
              'communication-type.subprocedure-sender.placeholder',
              'Seleziona endoprocedimento mittente...',
            )}
            style={{ width: '100%' }}
          />
        </FormItem>
      }
    />
  );
}
